import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields } from 'better-auth/client/plugins';
import { config } from '@/config/env';
import { betterAuthAdditionalFieldsSchema } from '@shared/betterAuth';

export const betterAuthClient = createAuthClient({
  baseURL: config.apiUrl,
  basePath: '/api/better-auth',
  plugins: [inferAdditionalFields(betterAuthAdditionalFieldsSchema)],
  fetchOptions: {
    credentials: 'include',
  },
});
